import script from "./PdpIngredientsList.vue?vue&type=script&setup=true&lang=js"
export * from "./PdpIngredientsList.vue?vue&type=script&setup=true&lang=js"

import "./PdpIngredientsList.vue?vue&type=style&index=0&id=60ef5f33&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60ef5f33"]])

export default __exports__